<template>
  <Bar :chart-options="getChartOptions" :chart-data="chartData" :chart-id="chartId" :dataset-id-key="datasetIdKey"
    :plugins="plugins" :css-classes="cssClasses" :styles="styles" :width="width" :height="height"
    @chart:rendered="chartRendered" @chart:destroyed="chartDestroyed" @chart:updated="chartUpdated"
    @labels:updated="labelsUpdated" ref="barChart" />
</template>

<script>
import { Bar } from "vue-chartjs/legacy";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  TimeScale,
} from "chart.js";


import { themeObserver, Themes } from "../../commons/colors";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  TimeScale
);
ChartJS.defaults.font.family = "ui-sans-serif, -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, 'Apple Color Emoji', Arial, sans-serif, 'Segoe UI Emoji', 'Segoe UI Symbol'";
ChartJS.defaults.font.size = 12;

export default {
  components: {
    Bar,
  },
  props: {
    chartId: {
      type: String,
      default: "bar-chart",
    },
    datasetIdKey: {
      type: String,
      default: "label",
    },
    width: {
      type: Number,
      default: 400,
    },
    height: {
      type: Number,
      default: 400,
    },
    cssClasses: {
      default: "",
      type: String,
    },
    styles: {
      type: Object,
      default: () => { },
    },
    plugins: {
      type: Array,
      default: () => []
    },
    horizontal: Boolean,
    stacked: Boolean,
    chartOptions: Object,
    chartData: Object,
  },
  data: () => ({
    observer: null,
    color: Themes.light.gray700,
    borderColor: Themes.light.gray100,
  }),
  methods: {
    handleClick(event) {
      const chart = this.$refs.barChart.$data._chart;
      let field = this.chartData.datasets[0].label;
      console.log(this.chartData.datasets)
      const points = chart.getElementsAtEventForMode(
        event,
        "nearest",
        { intersect: true },
        false
      );
      if (points.length) {
        const firstPoint = points[0];
        const label = this.chartData.labels[firstPoint.index];
        const value = this.chartData.datasets[0].data[firstPoint.index];
        this.$emit("segment-clicked", { field, label });
        // console.log({ label, value, index: firstPoint.index });
      }
    },
    updateChart() {
      this.$refs.barChart.updateChart();
    },
    chartRendered() {
      this.$emit("chart:rendered");
    },
    chartDestroyed() {
      this.$emit("chart:destroyed");
    },
    chartUpdated() {
      this.$emit("chart:updated");
    },
    labelsUpdated() {
      this.$emit("labels:updated");
    }
  },
  computed: {
    getChartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        borderWidth: 0,
        color: this.color,
        indexAxis: this.horizontal ? "y" : "x",
        scales: {
          x: {
            stacked: this.stacked,
            adapters: {
              date: {},
            },
            grid: {
              color: this.borderColor,
              borderColor: this.borderColor,
            },
            ticks: {
              color: this.color,
            },
          },
          y: {
            stacked: this.stacked,
            grid: {
              color: this.borderColor,
              borderColor: this.borderColor,
            },
            ticks: {
              color: this.color,
            },
          },
        },
        plugins: {
          legend: {
            labels: {
              boxWidth: 6,
              boxHeight: 6,
              usePointStyle: true,
            },
          },
          tooltip: {
            boxWidth: 6,
            boxHeight: 6,
            boxPadding: 3,
            usePointStyle: true,
          }
        },
        ...this.chartOptions,
      };
    },
  },
  mounted() {
    const target = document.body;
    const setColor = () => {
      if (target.classList.contains("dark")) {
        this.color = Themes.dark.gray700;
        this.borderColor = Themes.dark.gray100;
      } else {
        this.color = Themes.light.gray700;
        this.borderColor = Themes.light.gray100;
      }
    };
    setColor();
    /* mutation observer */
    this.observer = themeObserver(target, setColor, "bar");
    this.$refs.barChart.$el.addEventListener('click', this.handleClick);
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
    this.$refs.barChart.$el.removeEventListener('click', this.handleClick);
  }
};
</script>